angular.module("Main").controller("RegisterShortDialogController", ["$uibModal", "$uibModalInstance", "AuthenticationService", "BookingService", "data",
    function ($uibModal, $uibModalInstance, AuthenticationService, BookingService, data) {
        var vm = this;

        vm.nichtKostenlos = data.Preis > 0;
        vm.isVersionRegistration = false;

        BookingService.loadLayoutConfiguration().then(function (data) {
            vm.layoutSettings = angular.fromJson(data.Layout);
            vm.privacytermsText = data.PrivacyPolicy;
        });

        BookingService.getRegistrationConfig().then(function (regConfig) {
            vm.registrationRequiredFields = regConfig;
        })

        BookingService.getVersions().then(function (versionData) {
            vm.centerComVersion = versionData.centercomVersion;
            if(vm.centerComVersion >= "6.74.0.0") {
                vm.isVersionRegistration = true;
            }
        });


        $('#register-dialog-focus').focus();

        vm.startRegister = function (registration) {
            startRegister(registration);
        };

        vm.openPrivacyTerms = function () {
            $uibModal.open({
                templateUrl: "app/Main/views/dialogs/privacyTerms.html",
                controller: "BookingPrivacyTermsDialogController",
                controllerAs: "vm",
                resolve: {style: vm.layoutSettings[3]}
            });
        };

        vm.openForgotPassword = function (email) {
            vm.openFormForgotPassword = true;
            vm.openFormChangePassword = false;
            if (email !== null)
                vm.emailForgot = true;

            $uibModalInstance.dismiss();
            $uibModal.open({
                templateUrl: "app/Main/views/dialogs/forgotPassword.html",
                controller: "ForgotPasswordController",
                controllerAs: "vm",
                backdrop: "static",
                windowClass: 'position-class'
            });
        };

        function startRegister() {
            vm.dataForm.firstname.$setTouched();
            vm.dataForm.lastname.$setTouched();
            vm.dataForm.email.$setTouched();
            vm.dataForm.privacyterms.$setTouched();
            if(vm.centerComVersion >= "6.74.0.0") {
                if( vm.dataForm.birthday) {
                    vm.dataForm.birthday.$setTouched();
                }
            } else {
                vm.dataForm.birthday.$setTouched();
            }

            vm.hasError = false;
            vm.customError = false;
            if (vm.dataForm.$valid) {
                if (!vm.dataLoading) {
                    vm.dataLoading = true;

                    let regConfigText = "";
                    BookingService.getRegistrationConfig().then(function (regConfig) {
                        regConfigText = regConfig.SperreRegistrationText;
                        vm.registrationRequiredFields = regConfig;

                        var registrationData = {
                            email: vm.booking.email,
                            firstname: vm.booking.firstname,
                            lastname: vm.booking.lastname,
                            birthday: vm.booking.birthday
                        };
                        return BookingService.checkRegistration(registrationData);
                    }).then(function (dataRegistration) {
                        if (dataRegistration.IsLocked) {
                            vm.dataLoading = false;
                            vm.hasError = true;
                            vm.errorText = "LT_Email_gesperrt";
                        } else if (dataRegistration.uid) {
                            AuthenticationService.getNewPassword(dataRegistration.uid).then(function () {
                                vm.dataLoading = false;
                                vm.hasError = true;
                                vm.errorText = "LT_SHORT_REGISTRATION_LOGIN";
                            }).catch(function () {
                                vm.dataLoading = false;
                                vm.hasError = true;
                                vm.errorText = "LT_Es_ist_ein_Fehler_aufgetreten";
                            })
                        } else if (!dataRegistration.uid) {
                            vm.dataLoading = false;
                            vm.customError = true;
                            vm.errorText = regConfigText;
                        } else {
                            vm.dataLoading = false;
                            vm.hasError = true;
                            vm.errorText = "LT_Bitte_kontaktieren_Sie_Ihr_Studio";
                        }
                    }).catch(function (error) {
                        vm.dataLoading = false;
                        vm.hasError = true;
                        if (error.status === 409) {
                            vm.errorText = "LT_Bitte_kontaktieren_Sie_Ihr_Studio";
                        } else {
                            vm.errorText = "LT_Es_ist_ein_Fehler_aufgetreten_beim_Registrieren";
                        }
                    })
                }
            }
        }
    }]);